import { Body, CheckboxProps, FormLabel, FormMessage, Stack, Toggle } from '@optimus-web/core';
import { ControllerProps, useControllerWithEventHandler } from '../hooks';

export interface FormSwitchFieldProps
    extends Omit<CheckboxProps, 'value' | 'error' | 'name' | 'defaultValue'>,
        ControllerProps<boolean> {
    label: React.ReactNode;
    helper?: React.ReactNode;
    children?: React.ReactNode;
    tooltip?: React.ReactNode;
}

export const FormSwitchField = ({
    defaultValue,
    name,
    onChange,
    rules,
    shouldUnregister,
    transform,
    ...other
}: FormSwitchFieldProps) => {
    const { value, error, handleChange, onBlur, context } = useControllerWithEventHandler({
        defaultValue,
        name,
        onChange,
        rules,
        shouldUnregister,
        transform,
    });
    const props = {
        ...other,
        error,
        name,
        onBlur,
        onChange: handleChange,
        checked: value,
        disabled: context?.readOnly || other.disabled,
    };

    return (
        <Stack itemAlignment="center" distribution="space-between">
            <Stack vertical spacing="50">
                <FormLabel required={props.required}>
                    <Body>{props.label}</Body>
                </FormLabel>
                {props.helper && <FormMessage>{props.helper}</FormMessage>}
            </Stack>
            <Toggle {...props} />
        </Stack>
    );
};
